import { AmountButton } from 'src/app/shared/components/payments';

import { AmountInput } from '../../AmountInput';
import { ValidationErrorMessage } from '../ValidationErrorMessage';

import { useMultipleAmountSelector } from './hooks/useMultipleAmountSelector';

export function MultipleAmountSelector(): JSX.Element {
	const {
		data: { buttonAmounts, selection, currencySymbol, errorMessage, placeholder, customAmount, amountButtonProps },
		actions: { handleAmountChange, handleCustomAmountFocus, handleCustomAmountChange },
	} = useMultipleAmountSelector();

	return (
		<div className="mx-auto mt-2 w-full">
			<div className="grid grid-cols-4 gap-2">
				{buttonAmounts.map((value) => (
					<AmountButton
						{...amountButtonProps}
						dataQaAttribute={`membership_ask_multiple_buttons_amount_${value}`}
						key={value}
						amount={value}
						isSelected={selection === value}
						onClick={() => handleAmountChange(value)}
					/>
				))}
			</div>
			<div className="mt-3">
				<AmountInput
					currencySymbol={currencySymbol}
					errorMessage={errorMessage}
					onChange={handleCustomAmountChange}
					onFocus={handleCustomAmountFocus}
					value={customAmount ? Number(customAmount) : 0}
					placeholder={placeholder}
					height="56px"
				/>
			</div>
			<ValidationErrorMessage />
		</div>
	);
}
